const addGiftProductToCart = async (variantId, quantity) => {
    const url = '/cart/add.js';
    const data = { id: variantId,quantity: quantity,sections: ['mini-cart'] };

    try {
        const response = await fetch(url, {
            method: 'POST', 
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(data)
        });

        if (!response.ok) {throw new Error('Network response was not ok ' + response.statusText);}

        const responseJson = await response.json();
        console.log('Item added to cart:', responseJson);
        const cartResponse = await fetch(`${window.themeVariables.routes.cartUrl}.js`);
        const cartContent = await cartResponse.json();
        
        document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
            bubbles: true,
            detail: { cart: cartContent }
        }));
        
        cartContent["sections"] = responseJson["sections"];
        console.log('cartContent:', cartContent["sections"]);

        const miniCartStatus = document.querySelector('#mini-cart').getAttribute('open') === '';
        console.log(miniCartStatus);

        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: { cart: cartContent, openMiniCart: miniCartStatus }
        }));

        return true;
    } catch (error) {
        console.error('There was a problem with the fetch operation:', error);
        return false;
    }
};

const removeGiftProduct = async (variantId) => {
    const url = '/cart/update.js';
    const data = {
        id: variantId,
        quantity: 0,
        sections: ['mini-cart']
    };

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });

        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }

        const cart = await response.json();
        console.log('Item removed from cart:', cart);

        return true;
    } catch (error) {
        console.error('There was a problem with the fetch operation:', error);
        return false;
    }
};


function animateCounter(element, duration) {
  const end = parseInt(element.dataset.value);
  const startTime = performance.now();
  const updateCounter = (currentTime) => {
    const progress = Math.min(
      (currentTime - startTime) / duration,
      1
    );
    element.value = Math.floor(progress * end);
    if (progress < 1) requestAnimationFrame(updateCounter);
  };
  requestAnimationFrame(updateCounter);
}


const checkFreeGifts = (html) => {
    const freeGiftCircles = html.querySelectorAll('.rewardbar .rewardbar-freegift-circle');
    const cartProductItems = html.querySelectorAll('.drawer__content .line-item .product-item-meta__title');
    const activeCircle = Array.from(freeGiftCircles).find(circle => circle.classList.contains('active'));
    const dataProductValues = Array.from(freeGiftCircles).map(circle => circle.getAttribute('data-product')).filter(Boolean);

    animateCounter(document.getElementById("counterInput"), 2000);  
    
    console.log('Data Product Values:', dataProductValues);
    console.log('html', freeGiftCircles);

    let timer;
let timeLeft = 5 * 60; // 5 minutes
let countdownStarted = false;

function startCountdown() {
  if (countdownStarted) return; // prevent multiple timers
  countdownStarted = true;

  const countdownElement = document.getElementById("countdown");
  const greenBox = document.getElementById("countdownBox");
  const redBox = document.getElementById("countdown_redBox");

  function updateCountdown() {
    const minutes = Math.floor(timeLeft / 60);
    const seconds = timeLeft % 60;

    countdownElement.textContent = 
      `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;

    if (timeLeft <= 0) {
      clearInterval(timer);
      greenBox.style.display = "none";
      redBox.style.display = "flex";
    }

    timeLeft--;
  }

  // 800ms delay to let drawer render
  setTimeout(() => {
    updateCountdown(); // first call
    timer = setInterval(updateCountdown, 1000);
  }, 800);
}

        startCountdown();


    if (activeCircle) {
        const productData = activeCircle.getAttribute('data-product');
        console.log('Found an active element with data-product:', productData);

        const matchingCartItem = Array.from(cartProductItems).find(item => 
            item.getAttribute('data-variant') === productData
        );

        if (matchingCartItem) {
            console.log('A matching cart item with data-variant:', productData, 'was found.');
        } else {
            console.log('No matching cart item with data-variant:', productData, 'was found.');
            addGiftProductToCart(productData, 1).then((added) => {
                console.log('Added: ', added);
            });
        }
    } else {
        const matchingCartItems = Array.from(cartProductItems).filter(item =>
            dataProductValues.includes(item.getAttribute('data-variant'))
        );

        if (matchingCartItems.length > 0) {
            console.log('Matching cart items found:', matchingCartItems);
            matchingCartItems.forEach(item => {
                item.closest('.line-item__info').querySelector('.line-item__remove-button').click();
            });          
        } else {
            console.log('No matching cart items found.');
        }
    }
};
